module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      China Miéville, Tim Maughan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("CHINA MIÉVILLE is an author, activist, scholar, and comic writer. A leading influence in the New Weird movement, he has won numerous awards for his body of work which includes "), _c('I', [_vm._v("Perdido Street Station")]), _vm._v(","), _c('I', [_vm._v(" The Scar, The City & The City ")]), _vm._v("and"), _c('I', [_vm._v(" Embassytown.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qUw5Z2/tc-custom/9781466826021.jpg?1726024335748",
      "alt": "This image is the cover for the book King Rat"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("King Rat\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A young man discovers his identity among a tribe of rats in the renowned fantasy author’s \"riveting, brilliant novel\"—with an introduction by Tim Maughan (Charles de Lint).")]), _c('br'), _c('br'), _vm._v(" Something is stirring in London’s dark, stamping out its territory in brickdust and blood. Something has murdered Saul Garamond’s father, and left Saul to pay for the crime. But a shadow from the urban waste breaks into Saul’s prison cell and leads him to freedom: a shadow called King Rat."), _c('br'), _c('br'), _vm._v(" King Rat reveals to Saul his own royal heritage—a heritage that draws him into the grimy, magical world below London’s streets. With drum-and-bass pounding the backstreets, Saul must confront the forces that would use him, the ones that would destroy him, and those that have shaped his own bizarre identity."), _c('br'), _c('br'), _vm._v(" World Fantasy Award–winning author China Miéville began his astounding career with the novel "), _c('i', [_vm._v("King Rat")]), _vm._v(", which combines a young man’s search for identity with a pulse-pounding story of revenge and madness. This Tor Essential edition includes an introduction by Tim Maughan, author of "), _c('i', [_vm._v("Infinite Detail.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0